'use strict';

/**
 * Abstract storage adapter. To be extended by your own, or {@link AthomCloudAPI.StorageAdapterBrowser} or {@link AthomCloudAPI.StorageAdapterMemory}.
 * When creating your own, make sure to overload the `get` and `set` methods.
 * @class
 * @memberof AthomCloudAPI
 */
class StorageAdapter {

  /**
   * @returns {Promise<object>}
   */
  async get() {
    throw new Error('Not Implemented: StorageAdapter.get()');
  }

  /**
   * @param {object} value
   * @returns {Promise<void>}
   */
  // eslint-disable-next-line no-unused-vars
  async set(value) {
    throw new Error('Not Implemented: StorageAdapter.set()');
  }

}

module.exports = StorageAdapter;
